import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import type { FlagQaRecord } from "@/pages/admin/tables/flag-qa-types";
import { client } from "../client";

export const useFlagQaData = (merchantIds?: string[], startDate?: string, endDate?: string) => {
  return useQuery({
    queryKey: ["admin", "risk-flags", merchantIds?.join(",") ?? "all", startDate, endDate],
    queryFn: async (): Promise<FlagQaRecord[]> => {
      const res = await client.admin["risk-flags"].$get({
        query: {
          merchantId: merchantIds,
          startDate,
          endDate,
        },
      });
      if (!res.ok) throw await handleError(res);
      return (await res.json()) as FlagQaRecord[];
    },
  });
};

export const useFlagQaMerchants = () => {
  return useQuery({
    queryKey: ["admin", "risk-flags", "merchants"],
    queryFn: async () => {
      const res = await client.admin["risk-flags"].merchants.$get();
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
